import React, { Component } from 'react';
import AppHeader from '../AppHeader';
import AppFooter from '../AppFooter';
import Ad from '../Ad';
import NoIndex from "./NoIndex";
import ReactGA from 'react-ga';


class NotFound extends Component {


	componentDidMount() {
		ReactGA.ga('send', 'pageview', {
			'page': window.location.pathname + window.location.search,
			'title': '404 - Page not found'
		});
	}

	render() {
		return(
			<div className="App">

				<NoIndex />

				<AppHeader />

				<Ad type="leaderboard" />

				<main className="status-404 container">

					<h1>Seite nicht gefunden</h1>

					<p>Diese Seite ist leider nicht verfügbar.</p>
					<p><a href="/">Zur Startseite</a></p>

				</main>

				<AppFooter />
			</div>

		);
	}

}

export default NotFound;





// WEBPACK FOOTER //
// ./src/components/SEO/NotFound.js